import { datetime, date } from "../../utils";
import I18n from "../../I18n";

const STATUS = {
    0: "in_progress",
    1: "success",
    2: "error",
    3: "deleted",
    4: "pre_validation_success",
    5: "pre_validation_failed",
};
export const prepareGeneratedFileByStatus = (status) => {
    const statusObj = { generationStatus: status };
    switch (status) {
        case "error":
        case "pre_validation_failed":
            return {
                severity: "3",
                family: "error",
                ...statusObj,
            };
        case "in_progress":
            return {
                severity: "1",
                family: "warning",
                ...statusObj,
            };
        case "success":
        case "pre_validation_success":
            return {
                severity: "0",
                family: "success",
                ...statusObj,
            };
        case "deleted":
            return {
                ...statusObj,
            };
        default:
            return {};
    }
};
const mapCard = (json) => {
    const {
        message,
        userName,
        dateFrom,
        dateTo,
        fileType,
        createdAt,
        status,
        fileTypeName,
        fileName,
        id,
    } = json;
    const lineGenerationStatus = STATUS[status];

    const { family, severity, generationStatus } = prepareGeneratedFileByStatus(
        (lineGenerationStatus || "").toLowerCase(),
    );
    return [
        [
            {
                labels: ["message"],
                value:
                    message !== "undefined"
                        ? I18n.translate`${message}`
                        : "The file couldn't be generated. Please contact the support.",
                align: "left",
            },
        ],
        [{ labels: ["user"], value: userName, align: "left" }],
        [
            {
                labels: ["date_from"],
                value: date(dateFrom),
                type: "date",
                align: "center",
            },
        ],
        [
            {
                labels: ["date_to"],
                value: date(dateTo),
                type: "date",
                align: "center",
            },
        ],
        [
            {
                labels: ["file_type"],
                value: fileType ? fileType + " - " + (fileTypeName || "N/A") : "N/A",
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["request_at"],
                value: datetime(createdAt),
                type: "datetime",
                align: "center",
            },
        ],
        [
            {
                labels: ["status"],
                value: {
                    value: status,
                    label: I18n.translate`${lineGenerationStatus || "in_progress"}`,
                    severity,
                    family,
                    color: "main",
                    generationStatus,
                },
                type: "fileStatus",
            },
        ],
        [
            {
                labels: [""],
                value: {
                    id,
                    generationStatus,
                    customComponent: "GeneratorLineMoreActions",
                    entity: "generator",
                    name: fileName,
                },
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.id,
        name: `${json.id} ${json.fileName ? ` - ${json.fileName}` : ""}`,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        detailPanel: {
            data: json?.detailPanel?.data || undefined,
            detailPanelComponent: "GeneratorListDetails",
        },
    };
};

const header = [
    { label: ["Message"], align: "left", columnName: "message" },
    { label: ["User"], align: "left", mobileHidden: true, type: "userWithAvatar" },
    {
        label: ["date_from"],
        mobileHidden: true,
        align: "center",
    },
    {
        label: ["date_to"],
        mobileHidden: true,
        align: "center",
    },
    { label: ["file_type"], align: "center" },
    { label: ["requested_at"], mobileHidden: true, align: "center" },
    { label: ["Status"], mobileHidden: true, align: "center", type: "fileStatus" },
    { label: ["Actions"], type: "customComponent", align: "right" },
];

const generatordatafileMapper = {
    map: mapper,
    header,
    showCheckbox: true,
};

export default generatordatafileMapper;
